import AboutPageAboutUs from './components/AboutPageAboutUs';
import AboutPageDetails from './components/AboutPageDetails';
import AboutPageHeader from './components/AboutPageHeader';
import AboutPageHowToUse from './components/AboutPageHowToUse';
import background from '@/assets/about-us.jpg';
import HomePageTestimonials from '@/pages/Home/components/HomePageTestimonials.jsx';
import Layout from '@/components/Layout/Layout.jsx';
import SEO from '@/components/SEO/SEO.jsx';

const AboutPage = () => {
  return (
    <Layout>
      <SEO
        title='O nama – Rentasvet'
        description='Upoznajte tim iza Rentasveta – prvog srpskog sajta za rentiranje. Naša misija je da povežemo ljude koji nude i traže usluge rentiranja: vozila, alate, nekretnine i usluge. Bez posrednika, bez provizije.'
        keywords='o nama, Rentasvet tim, misija, srpski sajt za rentiranje, rentiranje Srbija, o kompaniji, prvi srpski sajt za rentiranje'
        url='/about'
        lang='sr'
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: 'O nama – Rentasvet',
          url: 'https://rentasvet.rs/about',
          description: 'Pri srpski sajt za rentiranje. Naša misija je da povežemo ljude bez posrednika i provizije.',
          publisher: {
            '@type': 'Organization',
            name: 'Rentasvet',
            url: 'https://rentasvet.rs',
            logo: 'https://rentasvet.rs/src/assets/favicon.png',
            sameAs: ['https://www.facebook.com/rentasvet', 'https://www.instagram.com/rentasvet'],
          },
        }}
      />
      <AboutPageHeader />
      <AboutPageAboutUs />
      <AboutPageDetails />
      <AboutPageHowToUse />
      <div className='h-96 w-full bg-cover bg-fixed bg-top' style={{ backgroundImage: `url(${background})` }}></div>
      <HomePageTestimonials />
    </Layout>
  );
};

export default AboutPage;
